import Store from 'store/store';
import { getCookie, setCookie } from 'utils/cookies';

const cookies = {
	closed: 'MCPopupClosed',
	subscribed: 'MCPopupSubscribed',
};

const showMailchimpPopup = (mailchimpData, isLanding) => {
	try {
		const { baseUrl, lid, uuid, landingDelay, ignoreClosedCookie, ignoreSubscribedCookie } = mailchimpData;

		if (ignoreClosedCookie) {
			setCookie(cookies.closed, '', -1000);
		}
		if (ignoreSubscribedCookie) {
			setCookie(cookies.subscribed, '', -1000);
		}

		const cookiePopupClosed = getCookie(cookies.closed);
		const cookieSubscribed = getCookie(cookies.subscribed);

		if (isLanding) {
			if (!cookiePopupClosed) {
				setTimeout(() => triggerPopup(baseUrl, lid, uuid), landingDelay * 1000);
			}
		} else {
			if (cookiePopupClosed) {
				setCookie(cookies.closed, '', -1000);
			}
			if (cookieSubscribed) {
				setCookie(cookies.subscribed, '', -1000);
			}
			triggerPopup(baseUrl, lid, uuid);
		}
	} catch (e) {}
};

const triggerPopup = (baseUrl, lid, uuid) => {
	if (typeof window.dojoRequire !== 'undefined') {
		mailchimpPopup(baseUrl, lid, uuid);
	} else {
		const untilDojoRequireIs = setInterval(() => {
			if (typeof window.dojoRequire !== 'undefined') {
				clearInterval(untilDojoRequireIs);
				mailchimpPopup(baseUrl, lid, uuid);
			}
		}, 200);
	}
};

const mailchimpPopup = (baseUrl, lid, uuid) => {
	window.dojoRequire(
		['mojo/signup-forms/Loader'],
		L => L.start({
			baseUrl,
			uuid,
			lid,
			uniqueMethods: true
		})
	);
};

Store.on('SUBSCRIBER_POPUP', (mailchimpData, isLanding) => {
	showMailchimpPopup(mailchimpData, isLanding);
});